import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  DataTableCell,
  TableBody as TableBodyPDF,
  TableCell as TableCellPDF,
  TableHeader as TableHeaderPDF,
} from "@david.kucsai/react-pdf-table";
import { TablePdf } from "../TablePdf/TablePdf";
import GetCurrency from "../../helper/GetCurrency";
import withIntl from "../../utils/withIntl";

function ViewPaymentMethodsTakeaway(props) {
  let totalCount = 0;
  let totalAmount = 0;
  let tipAmount = 0;
  let tipText = props.intl.formatMessage({ id: "Tip" });
  let payments = Object.keys(props.payments).map((paymentMethod) => {
    totalCount += props.payments[paymentMethod].count;
    totalAmount += props.payments[paymentMethod].amount;
    tipAmount += props.payments[paymentMethod].tipAmount;
    return (
      <TableRow key={paymentMethod}>
        <TableCell>{paymentMethod}</TableCell>
        <TableCell align={"right"}>{props.payments[paymentMethod].count}</TableCell>
        <TableCell align={"right"}>
          {GetCurrency()} {(props.payments[paymentMethod].amount / 100.0).toFixed(2)}
          {props.payments[paymentMethod].tipAmount > 0
            ? " + " + GetCurrency() + (props.payments[paymentMethod].tipAmount / 100.0).toFixed(2)
            : ""}
        </TableCell>
      </TableRow>
    );
  });

  const getPdfView = () => {
    return (
      <TablePdf
        data={Object.keys(props.payments).map((paymentMethod) => {
          return { paymentMethod: paymentMethod };
        })}
      >
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Betalingen</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Aantal
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {"Bedrag + " + tipText}
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r.paymentMethod} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => props.payments[r.paymentMethod].count} />
          <DataTableCell
            weighting={0.3}
            align={"right"}
            getContent={(r) => {
              let text = GetCurrency() + (props.payments[r.paymentMethod].amount / 100.0).toFixed(2);
              if (props.payments[r.paymentMethod].tipAmount > 0) {
                text += " + " + GetCurrency() + (props.payments[r.paymentMethod].tipAmount / 100.0).toFixed(2);
              }
              return text;
            }}
          />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {totalCount}
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {GetCurrency() +
              (totalAmount / 100.0).toFixed(2) +
              (tipAmount > 0 ? " + " + GetCurrency() + (tipAmount / 100.0).toFixed(2) : "")}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePdf>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Betalingen</TableCell>
            <TableCell align={"right"}>Aantal</TableCell>
            <TableCell align={"right"}>Bedrag + Fooi</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{payments}</TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{totalCount}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmount / 100.0).toFixed(2)}
              {tipAmount > 0 ? " + " + GetCurrency() + (tipAmount / 100.0).toFixed(2) : ""}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}

export default withIntl(ViewPaymentMethodsTakeaway);
